import React from "react"
import '../css/roadmap.css'
import { Link } from 'react-router-dom';
import roadmap from '../assets/roadmap.png';


function Roadmap() {
    return (
        <>

           
                <div className="coming-soon">

                    <span>C</span>
                    <span>O</span>
                    <span>M</span>
                    <span>I</span>
                    <span>N</span>
                    <span>G</span>
                    <span>&nbsp; </span>
                    <span>S</span>
                    <span>O</span>
                    <span>O</span>
                    <span>N</span>
                </div>
            
        </>)
}

export default Roadmap;